<template>
  <tr>
    <td :colspan="colspan" class="px-3 py-8 text-center text-muted">
      <template v-if="loading">
        <i class="fa fa-spin fa-spinner mr-2" aria-hidden="true"></i>
        {{ $t('message.loading') }}
      </template>
      <template v-else>
        {{ $t('message.no_records') }}
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'TableListStatus',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    colspan: {
      type: [Number, String],
      default: 1
    }
  }
}
</script>
